import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {ColumnId, IExportGroupProps} from "@ui/tableCustom/types/columns";
import ButtonToggleColumnExportGroup
    from "@containers/export/containers/buildData/view/buttons/buttonToggleColumnExport/ButtonToggleColumnExportGroups";
import ButtonToggleColumnExportBase
    from "@containers/export/containers/buildData/view/buttons/buttonToggleColumnExport/ButtonToggleColumnExportBase";


interface IProps<T> {
    exportMutate: IExportMutateContext<T>,
    exportParams: IExportParamsContext<T>,
    id: ColumnId<T>,
    exportGroupProps?: IExportGroupProps<T>,
}

function ButtonToggleColumnExport<T>({
                                         exportMutate,
                                         exportParams,
                                         id,
                                         exportGroupProps

                                     }: IProps<T>) {

    if (exportGroupProps?.rootGroupElement && exportGroupProps?.groupIds?.length) {
        return (
            <ButtonToggleColumnExportGroup
                exportMutate={exportMutate}
                exportParams={exportParams}
                exportGroupProps={exportGroupProps}
                id={id}
            />
        )
    }

    return (
        <ButtonToggleColumnExportBase
            exportMutate={exportMutate}
            id={id}
        />
    )
};
export default ButtonToggleColumnExport;
